import { matchPath } from "react-router-dom";

/**
 * Ordered most-specific first. Used with matchPath(..., { end: true }).
 */
const ROUTE_TITLES = [
	{ path: "/user/login", title: "Login" },
	{ path: "/auto-login", title: "Signing in" },
	{ path: "/dashboard/v3", title: "Dashboard" },
	{ path: "/dashboard/v2", title: "Dashboard" },
	{ path: "/dashboard/v1", title: "Dashboard" },
	{ path: "/dashboard", title: "Dashboard" },
	{ path: "/", title: "Dashboard" },
	{ path: "/staff/updateStaff/:UserName", title: "Update Staff" },
	{ path: "/staff/updatePassword/:UserName", title: "Update Password" },
	{ path: "/staff/weeklySchedule/:UserName", title: "Schedule" },
	{ path: "/staff/staffSchedule/:UserName", title: "Schedule" },
	{ path: "/staff/manageScheduleRoster/:UserName", title: "Schedule" },
	{ path: "/staff/manageScheduleRoster", title: "Schedule" },
	{ path: "/staff/StaffShiftReport/:UserName", title: "Staff Shift Report" },
	{ path: "/staff/payout/:UserName", title: "Staff Payout" },
	{ path: "/staff/manageStaff", title: "Manage Staff" },
	{ path: "/staff/AddStaff", title: "Add Staff" },
	{ path: "/staff/staffLeave", title: "Staff" },
	{ path: "/items/updateItem/:itemId", title: "Update Item" },
	{ path: "/items/createItem/:ProductType", title: "Create Item" },
	{ path: "/items/manageItems/:RootCat_ID", title: "Manage Items" },
	{ path: "/items/manageItems", title: "Manage Items" },
	{ path: "/items/bulkEditItems", title: "Bulk Edit Items" },
	{ path: "/deal/updateDeal/:dealId", title: "Update Deal" },
	{ path: "/deal/createDeal", title: "Create Deal" },
	{ path: "/deal/manageDeals", title: "Manage Deals" },
	{ path: "/menu/updateMenu/:menuId", title: "Update Menu" },
	{ path: "/menu/manageMenu", title: "Manage Menus" },
	{ path: "/menu/addMenu", title: "Add Menu" },
	{ path: "/role/updateRole/:roleId", title: "Update Role" },
	{ path: "/role/manageRole", title: "Manage Roles" },
	{ path: "/role/addrole", title: "Add Role" },
	{ path: "/tableManagement/updateAdvanceDeposit/:id", title: "Update Advance Deposit" },
	{ path: "/tableManagement/manageAdvanceDeposit", title: "Advance Deposits" },
	{ path: "/tableManagement/addAdvanceDeposit", title: "Add Advance Deposit" },
	{ path: "/tableManagement/menuPresets", title: "Menu Presets" },
	{ path: "/tableManagement/specialItems", title: "Special Items" },
	{ path: "/tableManagement/reservation", title: "Reservations" },
	{ path: "/tableManagement/serviceTime", title: "Service Time" },
	{ path: "/pettyCash/managePettyCash", title: "Petty Cash" },
	{ path: "/diningAreas/updateDiningArea/:sA_ID", title: "Update Dining Area" },
	{ path: "/diningAreas/addDiningArea", title: "Add Dining Area" },
	{ path: "/diningAreas", title: "Dining Areas" },
	{ path: "/customer/updateCustomer/:cusID", title: "Update Customer" },
	{ path: "/customerGroup/manageCustomerGroup", title: "Customer Groups" },
	{ path: "/customer/manageCustomer", title: "Customers" },
	{ path: "/customer/addCustomer", title: "Add Customer" },
	{ path: "/campaigns/manageCampaigns", title: "Campaigns" },
	{ path: "/marketing/updateMarketingGroup/:groupId", title: "Edit Marketing Group" },
	{ path: "/marketing/addMarketingGroup", title: "Create Marketing Group" },
	{ path: "/marketing/manageMarketingGroups", title: "Marketing Groups" },
	{ path: "/marketing/manageSmsPresets", title: "SMS Preset" },
	{ path: "/marketing/manageEmailPresets", title: "Email Preset" },
	{ path: "/marketing/addEmailPreset", title: "Create Email Preset" },
	{ path: "/marketing/updateEmailPreset/:presetId", title: "Edit Email Preset" },
	{ path: "/marketing/marketingSettings", title: "Marketing Settings" },
	{ path: "/loyalty/updateReward/:rewardId", title: "Update Reward" },
	{ path: "/loyalty/createReward", title: "Create Reward" },
	{ path: "/loyalty/rewards", title: "Loyalty Rewards" },
	{ path: "/loyalty/rules", title: "Loyalty Rules" },
	{ path: "/setting/Pricing&Subscriptions", title: "Pricing & Subscriptions" },
	{ path: "/setting/promotion-banners", title: "CDS Banners" },
	{ path: "/setting/online-ordering-banners", title: "Online Ordering Banners" },
	{ path: "/setting", title: "Settings" },
	{ path: "/Order/orderDetails/:orderId", title: "Order Details" },
	{ path: "/Order/manageOrder", title: "Orders" },
	{ path: "/discount/updatediscount/:discountId", title: "Update Discount" },
	{ path: "/discount/adddiscount", title: "Add Discount" },
	{ path: "/discount/manageDiscount", title: "Discounts" },
	{ path: "/Supplier/updateSupplier/:sID", title: "Update Supplier" },
	{ path: "/Supplier/manageSupplier", title: "Suppliers" },
	{ path: "/Supplier/addSupplier", title: "Add Supplier" },
	{ path: "/voucher/updateVoucher/:voucherId", title: "Update Voucher" },
	{ path: "/voucher/addVoucher", title: "Add Voucher" },
	{ path: "/voucher/manageVoucher", title: "Vouchers" },
	{ path: "/catering/services/manageServices", title: "Services" },
	{ path: "/modifiers/updateModifierGroup/:mGID", title: "Update Modifier Group" },
	{ path: "/modifiers/addModifierGroup", title: "Add Modifier Group" },
	{ path: "/modifiers/manageModifiers", title: "Manage Modifiers" },
	{ path: "/modifiers/manageModifierGroups", title: "Modifier Groups" },
	{ path: "/categories/updateCategory/:rootCatID", title: "Update Category" },
	{ path: "/categories/addCategory/:rootCatID", title: "Add Category" },
	{ path: "/categories/addCategory", title: "Add Category" },
	{ path: "/categories/createItem", title: "Create Item" },
	{ path: "/categories/manageCategories", title: "Categories" },
	{ path: "/report/loyaltyReport", title: "Loyalty Report" },
	{ path: "/report/zReport", title: "Z Report" },
	{ path: "/report/salesByProducts", title: "Sales by Products" },
	{ path: "/report/dealPerformance", title: "Combo Deal Performance" },
	{ path: "/report/cashReport", title: "Petty Cash Report" },
	{ path: "/report/salesBreakdownByTime", title: "Sales Breakdown by Time" },
	{ path: "/report/tableCover", title: "Table Cover Report" },
	{ path: "/report/tableSpent", title: "Table Spend Report" },
	{ path: "/report/staffWorkReport", title: "Staff Work Report" },
	{ path: "/report/AllStaffShiftReport", title: "All Staff Shift Report" },
	{ path: "/report/customerReport", title: "Customer Report" },
	{ path: "/manageReportingCategory", title: "Reporting Categories" },
	{ path: "/manageCategoryDepartments", title: "Category Departments" },
	{ path: "/printingReceipts", title: "Printing Receipts" },
	{ path: "/manageDevices", title: "Devices" },
	{ path: "/paymentMethod", title: "Payment Methods" },
	{ path: "/messaging/twilioSettings", title: "Twilio Settings" },
	{ path: "/messaging/smsTopUps", title: "SMS Top-ups" },
	{ path: "/messaging/smsTopUps/complete", title: "Confirming SMS Payment" },
	{ path: "/messaging/emailSenderSettings", title: "Email Sender Settings" },
	{ path: "/profile", title: "Profile" },
	{ path: "/subscription-invoices", title: "Subscription Invoices" },
	{ path: "/subscription-invoices/complete", title: "Confirming Payment" },
];

function normalizePathname(pathname) {
	if (!pathname) return "/";
	const p = pathname.endsWith("/") && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
	return p || "/";
}

/**
 * @param {string} pathname
 * @returns {string | null} Human-readable page title, or null if unknown.
 */
export function resolvePageTitle(pathname) {
	const normalized = normalizePathname(pathname);
	for (const { path, title } of ROUTE_TITLES) {
		if (matchPath({ path, end: true }, normalized)) {
			return title;
		}
	}
	return null;
}
